export default __webpack_public_path__ + "static/media/logo.8f52e8e0.png";